module.exports = __webpack_public_path__ + "static/img/003-1.6d0367b2.png";